import { Link, useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import { Fragment, useState, useEffect, useMemo } from "react";
//--------------------------------------------------------------------------------------------
import magnifierImg from "src/img/magnifier.png";
import Resize from "src/components/common/resize";
import UserInfo from "src/components/common/userInfo";
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Item from "src/components/common/frame/item";
import Export from "src/components/common/frame/export";
import FilterForm from "src/components/common/frame/filter";
import Detail from "src/components/common/frame/detail";
import { useMyStore } from "src/components/main/mainStore";
import {
    scroll, 
    MyFormData, 
    myAxios, 
    objAscSort, 
    objDescSort, 
    arrayReducer, 
    isDevMode,
    getTimeStamp,
    appTitle, 
} from "src/components/common/functions";
import Footer from "./footer";
//--------------------------------------------------------------------------------------------
export default function Items({
    setUpdateDateTime, 
    updateDateTime, 
    tabTitle, 
    postUrl, 
    dataFrame, 
    readLink, 
    createLink, 
    deleteLink, 
    numItemsPerColumn, 
    hashKeyName, 

    itemsExtended, 
    items, 
    setItems, 
    itemsRenderSwitch, 
    defaultSortKey, 
    defaultAscSort, 

    sqlTable, 
    itemLabel, 
    hashKeyLabel, 
    filesKey, 
    contacts, 

    width, 
    minWidth, 
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const curUser = useMyStore(state => state.user);
    const parseQuery = (str) => {
        const searchParams = new URLSearchParams(str);
        const result = {};
        for(let [key, value] of searchParams){
            if(value !== ""){
                result[key] = value;
            }
        }
        return result;
    }
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? "");

    const defaultQuery = useMemo(() => parseQuery(history.location.search.slice(1)), [history]);
    const defualtFilterWords = defaultQuery.filterWords || "";
    const defaultPage = window.parseInt(defaultQuery.currentPage || 1);
    const [showLoading, setShowLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(defaultPage);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [sortKey, setSortKey] = useState(defaultSortKey);
    const [ascSort, setAscSort] = useState(defaultAscSort || true);
    const [filterWords, setFilterWords] = useState(defualtFilterWords);
    const URLhashkey = history.location.pathname.split("/")[2];
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const defaultFilter = useMemo(() => 
    Object.fromEntries(
        dataFrame.map(item => 
            !["date", "number"].includes(item.type)?
            [[item.filterKey || item.key, item.defaultValue || ""]]:
            [[item.key + "Min", ""], [item.key + "Max", ""]]
        ).reduce((a,b) => arrayReducer(a, b), [])
    ), 
    [dataFrame]);
    const [curFilter, setFilter] = useState(defaultFilter);
    const filteredItemsList = useMemo(() => 
    itemsExtended.filter(u => 
        !filterWords.toLowerCase().split(" ").find(piece => JSON.stringify(Object.values(u)).toLowerCase().indexOf(piece) === -1)
        && 
        !dataFrame.find(item => !(
            !["date", "number"].includes(item.type)?
            (
                curFilter[item.filterKey || item.key] !== undefined && u[item.filterKey || item.key] !== undefined && curFilter[item.filterKey || item.key] !== defaultFilter[item.filterKey || item.key]?
                u[item.filterKey || item.key]?.toLowerCase().indexOf(curFilter[item.filterKey || item.key].toLowerCase()) > -1:true
            )
            :
            (
                item.type === "date"?
                (
                (curFilter[item.key + "Min"]?u[item.key] >= curFilter[item.key + "Min"]:true)
                && (curFilter[item.key + "Max"]?u[item.key] <= curFilter[item.key + "Max"]:true)
                ):
                (
                (curFilter[item.key + "Min"]?parseFloat(u[item.key]) >= parseFloat(curFilter[item.key + "Min"]):true)
                && (curFilter[item.key + "Max"]?parseFloat(u[item.key]) <= parseFloat(curFilter[item.key + "Max"]):true)
                )
            )
        ))
    )
    .sort((a, b) => ascSort?objAscSort(a, b, sortKey, {caseInsensitive: true}):objDescSort(a, b, sortKey, {caseInsensitive: true})), 
    [
        curFilter, ascSort, sortKey,
        defaultFilter, filterWords,
        itemsExtended, dataFrame, 
    ]);
    const currentItemsList = filteredItemsList.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredItemsList.length / itemsPerPage)}, (value, index) => (index + 1));
    const handleSubmit = async event => {
        event.preventDefault();
        const formData = new MyFormData(event.currentTarget);
        //-------------------------------------------------
        setShowLoader(true);
        const res = await myAxios(formData.get("url"),  formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------
        setItems(res.data);
        history.push(`/${path1}/`)
        
    }
    const deleteItem = async e => {
        if(window.confirm("Are you sure to delete this item?")){
            const formData = new MyFormData();
            formData.append(hashKeyName, e.currentTarget.id);
            //-------------------------------------------------
            setShowLoader(true);
            const res = await myAxios(deleteLink, formData);
            setShowLoader(false);
            if(!res) return;
            //-------------------------------------------------
            setItems(res.data);
            history.replace(`/${path1}`);
            scroll(null);
        }
    }
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            if(updateDateTime[tabTitle] === items.updatedAt) return;
            //-------------------------------------------------
            setShowLoading(true);
            const res = await myAxios(readLink, undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-------------------------------------------------
            setItems(res.data, updateDateTime[tabTitle]);
        }
        getData();
        return () => {
            isMounted = false;
            setShowLoader(false);
            controller.abort();
        }
    }, 
    [path1, history, itemsRenderSwitch, defaultPage, defaultQuery, hashKeyName, readLink, updateDateTime, tabTitle, items.updatedAt, setItems, setShowLoader])
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        const path2 = history.location.pathname.split("/")[2];
        if(!filteredItemsList.find(u => path2 === u[hashKeyName])){
            switch(path2){
                case "Add":
                    history.replace({search: new URLSearchParams(defaultQuery).toString()});
                    return; 
                case undefined:
                    history.replace({search: new URLSearchParams(defaultQuery).toString()});
                    return;
                default:
            }
            history.replace({path: `/${path1}`, search: new URLSearchParams(defaultQuery).toString()});
            return;
        }
        const hashkeys = filteredItemsList.map(item => item[hashKeyName]);
        const pageNumber = Math.ceil((hashkeys.indexOf(path2) + 1) / itemsPerPage);
        setCurrentPage(pageNumber);
        history.replace({search: new URLSearchParams(defaultQuery).toString()});
        scroll(path2);
        /*********************************************************/
        const totalPages = Math.ceil(filteredItemsList.length / itemsPerPage);
        if(totalPages !== 0 && defaultPage > totalPages){
            history.replace({search: new URLSearchParams({...defaultQuery, currentPage: 1}).toString()});
            setCurrentPage(1);
        }
    }, 
    [path1, hashKeyName, filteredItemsList, defaultPage, defaultQuery, history, itemsPerPage])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: curUser.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <button
                        type = "button"
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary ml-3"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </button>
                </span>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <FilterForm
                    setCurrentPage = {setCurrentPage}
                    setFilter = {setFilter}

                    curFilter = {curFilter}
                    dataFrame = {dataFrame}
                    defaultFilter = {defaultFilter}
                    
                    width = {width}
                    minWidth = {minWidth}
                />
                <Export
                    eportTitle = {tabTitle}
                    dataFrame = {dataFrame}
                    data = {filteredItemsList}
                />
                <button type = "button" className = "headerButton" onClick = {() => history.push(`/${path1}/Add`)}>Add</button>
                {URLhashkey === "Add"?
                <Item
                    numItemsPerColumn = {numItemsPerColumn}
                    path1 = {path1}
                    postUrl = {createLink}
                    keyword = "Add"
                    closeIt = {() => history.push(`/${path1}`)}
                    handleSubmit = {handleSubmit}
                    item = {{}}
                    hashKeyName = {hashKeyName}
                    dataFrame = {dataFrame}
                    history = {history}

                    contacts = {contacts}
                />
                :<></>}
            </div>
            <div className = {"cssContent" + (!showLoading && filteredItemsList.length?" pb10":"")}>
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !currentItemsList.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead>
                            <tr className = "noBorderTop">
                                <th></th>
                                {dataFrame.filter(elem => elem.position === "title").map((elem, elemIndex) => 
                                <th key = {elemIndex}>
                                    <button
                                        type = "button"
                                        className = "noButtonStyle pointer text-nowrap"
                                        onClick = {() => {
                                            if(sortKey === elem.key){
                                                setAscSort(a => !a);
                                            }else{
                                                setAscSort(true);
                                                setSortKey(elem.key);
                                            }
                                            const prevQuery = parseQuery(history.location.search.slice(1));
                                            const searchString = new URLSearchParams({...prevQuery, currentPage: 1 }).toString();
                                            history.push({ search: searchString });
                                            setCurrentPage(1);
                                        }}
                                    >
                                        {elem.title}
                                        {elem.key === sortKey?
                                        <span>{ascSort?"⬆️":"⬇️"}</span>
                                        :<></>}
                                    </button>
                                </th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {
                            currentItemsList.map((item, key) => 
                            <Fragment key = {key}>
                            <tr>
                                <td>
                                    <button
                                        id = {item[hashKeyName]}
                                        type = "button"
                                        className = {(URLhashkey === item[hashKeyName]?"showMinus":"showPlus") + " childRow"}
                                        onClick = {e => {
                                            if(URLhashkey !== e.currentTarget.id){
                                                history.push(`/${path1}/${e.currentTarget.id}`);
                                                scroll(e.currentTarget.id);
                                            }else{
                                                history.push(`/${path1}`);
                                                scroll(null);
                                            }
                                        }}
                                    />
                                </td>
                                {dataFrame.filter(elem => elem.position === "title").map((elem, elemIndex) => <td key = {elemIndex}>
                                    <span>
                                        {elem.valueType === undefined?item[elem.key]:""}
                                        {elem.valueType === "link" && item[elem.key]?
                                        <a
                                            href = {!item[elem.key]?.startsWith("http")?"http://" + item[elem.key]:item[elem.key]}
                                            target = "_blank"
                                            rel = "noreferrer"
                                        >
                                            {item[elem.key]}
                                        </a>
                                        :<></>}
                                        {elem.valueType === "internalLink" && item[elem.key]?
                                        <Link
                                            to = {
                                                elem.target
                                                .replace("{{value}}", item[elem.key])
                                                .replace("{{selectValue}}", item[elem.selectKey])
                                            }
                                        >
                                            {item[elem.key]}
                                        </Link>
                                        :<></>}
                                        {elem.valueType === "phone" && item[elem.key]?
                                        <a
                                            href = {"tel:+1" + item[elem.key]}
                                            target = "_blank"
                                            rel = "noreferrer"
                                        >
                                            {item[elem.key]}
                                        </a>
                                        :<></>}
                                        {elem.valueType === "email" && item[elem.key]?
                                        <a
                                            href = {"mailto:" + item[elem.key]}
                                            target = "_blank"
                                            rel = "noreferrer"
                                        >
                                            {item[elem.key]}
                                        </a>
                                        :<></>}
                                        {elem.valueType === "userInfo"?
                                        <UserInfo
                                            name = {item[elem.userInfoName]}
                                            email = {item[elem.userInfoEmail]}
                                        />
                                        :""}
                                        
                                        {elem.suffix?
                                        <span className = "ml-2">
                                            {item[elem.suffix]}
                                        </span>
                                        :<></>}
                                    </span>
                                </td>)}
                            </tr>
                            <tr>
                                <td className = "noborder" colSpan = {100}>
                                    <TransitionWidthHeight 
                                        classNames = "cssTDTransition"
                                        In = {history.location.pathname.split("/")[2] ===  item[hashKeyName]}
                                    >
                                        <Detail
                                            numItemsPerColumn = {numItemsPerColumn}
                                            path1 = {path1}
                                            hashKeyName = {hashKeyName}
                                            item = {item}
                                            items = {items}
                                            setItems = {setItems}
                                            dataFrame = {dataFrame}
                                            postUrl = {postUrl}

                                            history = {history}
                                            deleteItem = {deleteItem}
                                            handleSubmit = {handleSubmit}

                                            sqlTable = {sqlTable}
                                            itemLabel = {itemLabel}
                                            hashKeyLabel =  {hashKeyLabel}
                                            filesKey = {filesKey}

                                            contacts = {contacts}
                                        />
                                    </TransitionWidthHeight>
                                </td>
                            </tr>
                            </Fragment>
                            )}
                        </tbody>
                    </table>
                </div>
                }
                {!showLoading && filteredItemsList.length?
                <Footer
                    length = {filteredItemsList.length}
                    pageNumbers = {pageNumbers}
                    
                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}